export default "__VITE_ASSET__HEtGTcUK__"